export default __webpack_public_path__ + "static/sparklePay-9b7bb4e2783b343a93a10ba8ac930b09.svg";